import { render } from "./editVersion.vue?vue&type=template&id=3d36d272&scoped=true"
import script from "./editVersion.vue?vue&type=script&lang=js"
export * from "./editVersion.vue?vue&type=script&lang=js"

import "./editVersion.vue?vue&type=style&index=0&id=3d36d272&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d36d272"]])

export default __exports__